<p-progressBar
  *ngIf="show"
  [mode]="mode"
  [style]="{ height: height }"
></p-progressBar>
